module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0b7f8bdc3a1bdb087034873a07168d76.png";